module.exports = __webpack_public_path__ + "img/0Q3B3332_P_T_L_Foamcore_MockedUp.1b9c2c6b.jpg";